window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  document.getElementById("width").value="";
  document.getElementById("depth").value="";
  document.getElementById("height").value="";
  document.getElementById("price").value="";
  document.getElementById("material").innerHTML = "選択してください";
  document.getElementById("material2nd").innerHTML = "選択してください";
  var cancel = document.querySelectorAll("input[type='radio']");
 for (const i of cancel) {i.checked = false;}
  document.querySelector("input[type='radio'][value='スクエア']").checked = true;
  cartReset();resizing();
}
window.onresize = function(){resizing();}

//カート中身リセット
function cartReset(){
  document.getElementById("price").value="";
    cart_price.innerHTML =""+" 円";
    cart_option.innerHTML="";
    cart_width.innerHTML=""; 
    cart_depth.innerHTML=""; 
    cart_height.innerHTML="";
    cart_color1st.innerHTML="";
    cart_color2nd.innerHTML="";
    linkmsg.style.visibility="hidden";
}

document.onkeypress = function(e){// エンター無効
  if (e.key === 'Enter') {return false;}
}

//画像リサイズ
function resizing(){
  var size_acquisition = document.getElementById("size_acquisition");
  var hsize = size_acquisition.clientHeight;
  $(".size_img").css("height",hsize+"px");
  //$(".size_img div:nth-child(3)").css("height",hsize+"px");
  //$(".size_img div:nth-child(3)").css({height:hsize+"px",'margin-left':'7%'});
  //$(".size_img div img").css({height:hsize+"px",'margin-right':'6%'});
  $(".size_img div img").css("height",hsize+"px");
  //changeSize();
}



//サイズ入力時
function changeSize(){
  var width=document.getElementById("width").value;
  var depth=document.getElementById("depth").value;
  var height=document.getElementById("height").value;
  var imgW = "180";
  var imgD = "90";
  var imgH = "90";
  switch(imgW != null){
    case width == "": imgW = "180";
    $(".size_img div:nth-of-type(2)").css("margin-right","7%");break;
    case width <= 100: imgW = "90";
    $(".size_img div:nth-of-type(1)").css("margin-left","6%");
    $(".size_img div:nth-of-type(2)").css("margin-right","44%");break;
    case width <= 130: imgW = "120";
    $(".size_img div:nth-of-type(2)").css("margin-right","32%");break;
    case width <= 160: imgW = "150";
    $(".size_img div:nth-of-type(1)").css("margin-left","6%");
    $(".size_img div:nth-of-type(2)").css("margin-right","21%");break;
    default:imgW = "180";
    $(".size_img div:nth-of-type(2)").css("margin-right","7%");
  }
  switch(imgD != null){
    case depth == "": imgD = "90";break;
    case depth <= 60: imgD = "50";
    $(".size_img div:nth-of-type(1) img").css("margin-left","22px");
    $(".size_img div:nth-of-type(2) img").css("margin-right","22px");break;
    case depth <= 80: imgD = "70";
    $(".size_img div:nth-of-type(1) img").css("margin-left","18px");
    $(".size_img div:nth-of-type(2) img").css("margin-right","18px");break;
    default:imgD = "90";
    $(".size_img div:nth-of-type(1) img").css("margin-left","0px");
    $(".size_img div:nth-of-type(2) img").css("margin-right","0px");
  }
  switch(imgH != null){
    case height == "": imgH = "90";break;
    case height <= 50: imgH = "40";break;
    case height <= 80: imgH = "70";break;
    default:imgH = "90";
  }
  var topBoardsize = imgW+imgD;
  var legsize = imgD+imgH;
  var changeImgUrl = $(document.area2).attr("src").split("/");
  var changeImgUrl = $(document.area2).attr("src").replace(changeImgUrl[10] , topBoardsize);
  $(document.area2).attr("src", changeImgUrl+".png");
  var changeImgUrl = $(document.area3).attr("src").split("/");
  var changeImgUrl = $(document.area3).attr("src").replace(changeImgUrl[10] , legsize);
  $(document.area3).attr("src", changeImgUrl+".png");
  var changeImgUrl = $(document.area4).attr("src").split("/");
  var changeImgUrl = $(document.area4).attr("src").replace(changeImgUrl[10] , legsize);
  $(document.area4).attr("src", changeImgUrl+".png");
  size_acquisition.style.visibility="hidden";
  //resizing();
}

//材質切替 <br class=\"delete\">
function materialWood(){document.getElementById("material").innerHTML = "リーズナブル木目：<br>[材質]強化紙化粧合板、プリント化粧合板";}
function materialMela(){document.getElementById("material").innerHTML = "ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)";}
function materialWood2nd(){document.getElementById("material2nd").innerHTML = "リーズナブル木目：<br>[材質]強化紙化粧合板、プリント化粧合板";}
function materialMela2nd(){document.getElementById("material2nd").innerHTML = "ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)";}

function topBoard(changeImg){
  var colorList = document.getElementsByName("color_topBoard");
  var cancel = document.querySelectorAll("input[type='radio'][name='color_leg']");
  for (const i of cancel) {i.checked = false;}
  document.getElementById("material2nd").innerHTML = "選択してください";
  if(changeImg<=6){
    var chooseColor=colorList[changeImg].id.slice(5);
    $(".box2nd div").slice(1,8).css('display', 'inline-block');
    $(".box2nd div").slice(8).css('display', 'none');
  }
  else {
    var chooseColor=colorList[changeImg].id;
    $(".box2nd div").slice(1,8).css('display', 'none');
    $(".box2nd div").slice(8).css('display', 'inline-block');
  }

  let imgColor = $(document.area2).attr("src").split("/");
  imgColor = $(document.area2).attr("src").replace(imgColor[9] , chooseColor+"_color");
  $(document.area2).attr('src', imgColor);
}
function leg(changeImg){
  let imgLeg = document.querySelectorAll("[name='area3'], [name='area4']");
  var colorList = document.getElementsByName("color_leg");
  if(changeImg<=6){var chooseColor=colorList[changeImg].id.slice(5,-3);}
  else {var chooseColor=colorList[changeImg].id.slice(0,-3);}

  let imgColor = $(imgLeg).attr("src").split("/");
  imgColor = $(imgLeg).attr("src").replace(imgColor[9] , chooseColor+"_color");
  $(imgLeg).attr('src', imgColor);
}

//リアルタイムサイズチェック
function changeMsg(){
  var width=Number(document.getElementById("width").value);
  var depth=Number(document.getElementById("depth").value);
  var height=Number(document.getElementById("height").value);
  sizemsg.style.visibility="hidden";
  cartReset();
  if (width==0||depth==0||height==0){document.getElementById("sizemsg").innerHTML = "<p> </p>";return false;}
  if (width < 90 || width > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 幅90cm未満・幅181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
  if (depth < 60 || depth > 90){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行60cm未満・91cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
  if (height < 40 || height > 90){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ40cm未満・91cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
  //if (height > 71 && depth < 55){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ72cm以上かつ奥行54cm以下はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
  document.getElementById("sizemsg").innerHTML = "<p> </p>";
}





//サイズオーダー
const strLink1="<a href=\"https://item.rakuten.co.jp/arne-style/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,width,depth,height,option,color){
this.url=url;this.width=width;this.depth=depth;this.height=height;this.option=option;this.color=color;}

function searchURL(strWidth,strDepth,strHeight,strOption,strColor1st){
  var strErr;

  //サイズチェック
  if (strWidth < 90 || strWidth > 180){strErr="幅90cm未満・幅181cm以上は";}
  else if (strDepth < 60 || strDepth > 90){strErr="奥行60cm未満・奥行91cm以上は";}
  else if (strHeight < 40 || strHeight > 90){strErr="高さ40cm未満・高さ91cm以上は";}
  //else if (strHeight > 71 && strDepth < 55){strErr="高さ72cm以上かつ奥行54cm以下は";}
  if(strErr){document.getElementById("price").value="";
  return strErr+"オーダー不可です。";}

  var priceW;
  var priceD;

  //幅サイズ成形
  if(priceW == null){
    priceW = Math.ceil(strWidth/10) * 10;
    priceW = priceW-90;
    priceW = priceW/10;
  }

  //奥行サイズ成形
  if(priceD == null){
    priceD = Math.ceil(strDepth/10) * 10;
    priceD = priceD-50;
    priceD = priceD/10;
    if(strColor1st == "nail" || strColor1st == "bk"){priceD = priceD+5;}
    else if(strColor1st == "bp"){priceD = priceD+10;}
    else if(strColor1st == "mb" || strColor1st == "gs" || strColor1st == "ww"){priceD = priceD+15;}
  }
  
  var arr = csvToArray("https://cdn.shopify.com/s/files/1/0549/1834/8887/files/arnetable_price.csv?v=1668839018");
  var sellPrice = arr[priceD][priceW];
  return sellPrice;

  function csvToArray(filename) {

    var srt = new XMLHttpRequest();
    srt.open("GET", filename, false);
    try {
      srt.send(null);
    } catch (err) {
      console.log(err)
    }
    var csvArr = [];
    var lines = srt.responseText.split("\n");
    for (var i = 0; i < lines.length; ++i) {
      var cells = lines[i].split(",");
      if (cells.length != 1) {
        csvArr.push(cells);
      }
    }
    return csvArr;
  }
  
}
















/*リストから商品URLを取得*//*削除*/
function checkURL(strWidth,strDepth,strHeight,strOption,strColor1st){
switch(true){
 default:
  for(var i in goods){
if(goods[i].width==strWidth && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].option==strOption && goods[i].color==strColor1st){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var idOption=document.getElementsByName("option");
var strWidth=document.getElementById("width").value;
var strDepth=document.getElementById("depth").value;
var strHeight=document.getElementById("height").value;
var idColor1st = document.getElementsByName("color_topBoard");
var idColor2nd = document.getElementsByName("color_leg");
var strColor1st = "";
var strColor2nd = "";
var strOption = "";
var i=0;
var c=0;
for ( strColor1st="", i=idColor1st.length; i--; ) {
 if ( idColor1st[i].checked ) {
     if( idColor1st[i].id.slice(0,4)=="wood" ){
         strColor1st = idColor1st[i].id.slice(0,4);
     }else{
         strColor1st = idColor1st[i].id;
     }
  var valueColor1st = idColor1st[i].value ;
  break ;
 }
}
for ( strColor2nd="", i=idColor2nd.length; i--; ) {
 if ( idColor2nd[i].checked ) {
     if( idColor1st[i].id.slice(0,4)=="wood" ){
         strColor2nd = idColor2nd[i].id.slice(0,4);
     }else{
         strColor2nd = idColor2nd[i].id.slice(0,-3);
     }
  var valueColor2nd = idColor2nd[i].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var valueOption = idOption[c].value ;
  break ;
 }
}


if (isNumber(strWidth)==false){alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");return false;}
if (isNumber(strDepth)==false){alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
if (isNumber(strHeight)==false){alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
if (strColor1st==false){alert("天板カラーを選択してください");return false;}
if (strColor2nd==false){alert("脚カラーを選択してください");return false;}

document.getElementById("choice2").value= valueOption
document.getElementById("choice3").value= strWidth+"cm"
document.getElementById("choice4").value= strDepth+"cm"
document.getElementById("choice5").value= strHeight+"cm"
document.getElementById("choice6").value= valueColor1st
document.getElementById("choice7").value= valueColor2nd
//商品ページの有無チェック
var comcode=checkURL(strWidth,strDepth,strHeight,strOption,strColor1st);
if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strWidth,strDepth,strHeight,strOption,strColor1st);

if(!url){
alert("幅、奥行、高さを選んでください");
return false;
}

var total;
if(strHeight <= 42){total = 0;}
else if(strHeight <= 60){total = 2000;}
else if(strHeight <= 72){total = 4000;}
else if(strHeight <= 90){total = 6000;}

/*var total = [2000];
switch(total != null){
case strHeight <= 42: total == total[0]*0; break;
case strHeight <= 60: total == total[0]*1; break;
case strHeight <= 72: total == total[0]*2; break;
case strHeight <= 90: total == total[0]*3; break;
}*/
var intUnit;
if (isNaN(url)==false){
  intUnit=(parseInt(url)+total)/1000;//1000円単位
  document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
  cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
  cart_option.innerHTML=valueOption;
  cart_width.innerHTML=strWidth;
  cart_depth.innerHTML=strDepth;
  cart_height.innerHTML=strHeight;
  cart_color1st.innerHTML=valueColor1st;
  cart_color2nd.innerHTML=valueColor2nd;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice1").value="見積もり金額："+(parseInt(url)+total);
return false;
}



function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice4=document.frm.choice5.value;
 var choice6=document.frm.choice6.value;
 var choice7=document.frm.choice7.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice3=="" || choice4=="" || choice5=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000ae019137","90","50","42","sq","wood");
goods[1] =new setGoods("0000ae019144","90","70","42","sq","wood");
goods[2] =new setGoods("0000ae019151","90","90","42","sq","wood");
goods[3] =new setGoods("0000ae019158","120","50","42","sq","wood");
goods[4] =new setGoods("0000ae019165","120","70","42","sq","wood");
goods[5] =new setGoods("0000ae019172","120","90","42","sq","wood");
goods[6] =new setGoods("0000ae019179","150","50","42","sq","wood");
goods[7] =new setGoods("0000ae019186","150","70","42","sq","wood");
goods[8] =new setGoods("0000ae019193","150","90","42","sq","wood");
goods[9] =new setGoods("0000ae019200","180","50","42","sq","wood");
goods[10] =new setGoods("0000ae019207","180","70","42","sq","wood");
goods[11] =new setGoods("0000ae019214","180","90","42","sq","wood");
goods[12] =new setGoods("0000ae019221","90","50","72","sq","wood");
goods[13] =new setGoods("0000ae019228","90","70","72","sq","wood");
goods[14] =new setGoods("0000ae019235","90","90","72","sq","wood");
goods[15] =new setGoods("0000ae019242","120","50","72","sq","wood");
goods[16] =new setGoods("0000ae019249","120","70","72","sq","wood");
goods[17] =new setGoods("0000ae019256","120","90","72","sq","wood");
goods[18] =new setGoods("0000ae019263","150","50","72","sq","wood");
goods[19] =new setGoods("0000ae019270","150","70","72","sq","wood");
goods[20] =new setGoods("0000ae019277","150","90","72","sq","wood");
goods[21] =new setGoods("0000ae019284","180","50","72","sq","wood");
goods[22] =new setGoods("0000ae019291","180","70","72","sq","wood");
goods[23] =new setGoods("0000ae019298","180","90","72","sq","wood");